// extracted by mini-css-extract-plugin
export var grid = "_1z-0";
export var span1 = "_1z-2";
export var span10 = "_1z-b";
export var span10L = "_1z-z";
export var span10M = "_1z-n";
export var span10Xl = "_1z-1b";
export var span11 = "_1z-c";
export var span11L = "_1z-10";
export var span11M = "_1z-o";
export var span11Xl = "_1z-1c";
export var span12 = "_1z-d";
export var span12L = "_1z-11";
export var span12M = "_1z-p";
export var span12Xl = "_1z-1d";
export var span1L = "_1z-q";
export var span1M = "_1z-e";
export var span1Xl = "_1z-12";
export var span2 = "_1z-3";
export var span2L = "_1z-r";
export var span2M = "_1z-f";
export var span2Xl = "_1z-13";
export var span3 = "_1z-4";
export var span3L = "_1z-s";
export var span3M = "_1z-g";
export var span3Xl = "_1z-14";
export var span4 = "_1z-5";
export var span4L = "_1z-t";
export var span4M = "_1z-h";
export var span4Xl = "_1z-15";
export var span5 = "_1z-6";
export var span5L = "_1z-u";
export var span5M = "_1z-i";
export var span5Xl = "_1z-16";
export var span6 = "_1z-7";
export var span6L = "_1z-v";
export var span6M = "_1z-j";
export var span6Xl = "_1z-17";
export var span7 = "_1z-8";
export var span7L = "_1z-w";
export var span7M = "_1z-k";
export var span7Xl = "_1z-18";
export var span8 = "_1z-9";
export var span8L = "_1z-x";
export var span8M = "_1z-l";
export var span8Xl = "_1z-19";
export var span9 = "_1z-a";
export var span9L = "_1z-y";
export var span9M = "_1z-m";
export var span9Xl = "_1z-1a";
export var stretch = "_1z-1";